import { injectable } from "inversify";
import WCCSliderAdaptiveLayout from "../layouts/adaptive";
import WCCSliderDynamicLayout from "../layouts/dynamic";
import WCCSliderFullscreenLayout from "../layouts/fullscreen";
import { IWCCSliderLayout } from "../layouts/layout.interfaces";
import { ExtendedWCCSliderAdaptiveLayoutConfig, ExtendedWCCSliderDynamicLayoutConfig, ExtendedWCCSliderFullscreenLayoutConfig, ExtendedWCCSliderLayoutConfig, IWCCSliderLayoutsFactory } from "./layout.interfaces";

@injectable()
export default class WCCSliderLayoutsFactory<T> implements IWCCSliderLayoutsFactory<T> {
    constructor() { }

    build(config: ExtendedWCCSliderLayoutConfig<T>): IWCCSliderLayout<T> {
        const type = config.type;

        switch (type) {
            case 'dynamic':
                return new WCCSliderDynamicLayout(<ExtendedWCCSliderDynamicLayoutConfig<T>>config) as any;
            case 'fullscreen':
                return new WCCSliderFullscreenLayout(<ExtendedWCCSliderFullscreenLayoutConfig<T>>config);
            default:
                return new WCCSliderAdaptiveLayout(<ExtendedWCCSliderAdaptiveLayoutConfig<T>>config);
        }
    }
}